var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";
import actions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import transactionJourneyActions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
var DraftOrdersAlert = function (_a) {
    var _b, _c;
    var viewOrders = _a.viewOrders, setViewOrders = _a.setViewOrders;
    var _d = __read(useState(true), 2), alertShown = _d[0], setAlertShown = _d[1];
    var _e = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), draftOrderCount = _e.draftOrderCount, watchListRequestPayload = _e.watchListRequestPayload;
    var draftOrdersRequestPayload = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).draftOrdersRequestPayload;
    var cActions = new actions();
    var cTransactionJourneyActions = new transactionJourneyActions();
    var lastValidCountRef = useRef(0);
    var currentCount = (_b = draftOrderCount === null || draftOrderCount === void 0 ? void 0 : draftOrderCount.data) === null || _b === void 0 ? void 0 : _b.count;
    useEffect(function () {
        getCounts();
    }, []);
    var getCounts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var countResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, otcDi.productBouquet.getDraftOrderCount({
                        categoryCode: Number(watchListRequestPayload.category_code),
                        buy_sell_Flag: watchListRequestPayload.buysellflg,
                    })];
                case 1:
                    countResponse = _b.sent();
                    lastValidCountRef.current = (_a = countResponse === null || countResponse === void 0 ? void 0 : countResponse.data) === null || _a === void 0 ? void 0 : _a.count;
                    cActions.getDraftOrderCount(countResponse);
                    return [2 /*return*/];
            }
        });
    }); }, [watchListRequestPayload, lastValidCountRef]);
    var countToDisplay = (_c = lastValidCountRef.current) !== null && _c !== void 0 ? _c : 0;
    var showAlert = (lastValidCountRef.current > 0 && alertShown) || viewOrders;
    return showAlert ? (React.createElement(Alert, { bsPrefix: "aif-pms-alert", variant: "warning", className: "d-flex justify-content-between align-items-center" },
        React.createElement("div", { className: "d-flex gap-3 align-items-center" },
            React.createElement("i", { className: "edel-icon-attention txt-orange-light", style: { fontSize: 22 } }),
            React.createElement("div", { className: "d-flex align-items-center gap-3" },
                React.createElement("p", { className: "content DMSanN_14_400 txt-midnight-blue fw-400" },
                    React.createElement("b", { className: "fw-600" },
                        "You have ",
                        countToDisplay,
                        " draft orders"),
                    ". Please review and complete them to proceed."),
                React.createElement(Alert.Link, { className: "DMSanN_14_400 txt-han-blue font-weight-400 text-decoration-none", onClick: function () {
                        setViewOrders(true);
                        cTransactionJourneyActions.updateDraftOrdersRequestPayload(__assign(__assign({}, draftOrdersRequestPayload), { categoryCode: watchListRequestPayload.category_code, page_index: 1, page_size: 10, orderbydesc: false, orderby: "display_name", buy_sell_Flag: watchListRequestPayload.buysellflg }));
                    } },
                    React.createElement("span", { className: "text-decoration-underline me-1" }, "View Orders"),
                    React.createElement("i", { style: { fontSize: 12 }, className: "edel-icon-arrow-right1 " }),
                    " "))),
        React.createElement("i", { onClick: function () {
                cActions.getDraftOrders(null);
                setAlertShown(false);
            }, className: "edel-icon-close d-flex justify-content-center align-items-center text-han-blue cursor-pointer" }))) : null;
};
export default DraftOrdersAlert;
